import { render, staticRenderFns } from "./ChatbotThreadsFiltering.vue?vue&type=template&id=d042832c&scoped=true&"
import script from "./ChatbotThreadsFiltering.vue?vue&type=script&lang=js&"
export * from "./ChatbotThreadsFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d042832c",
  null
  
)

export default component.exports